import { useQuery } from '@tanstack/react-query';
import { testsApi } from '../lib/api';
import { fetchAllPages } from '../lib/pagination';
import type { Test, PaginatedResponse } from '../lib/types';

export function useTestHistory(params?: {
  search?: string;
  limit?: number;
  lastKey?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  page?: number;
  fetchAll?: boolean;
}) {
  return useQuery<PaginatedResponse<Test>>({
    queryKey: ['testHistory', params],
    queryFn: async () => {
      if (params?.fetchAll === true) {
        // Only fetch all pages if explicitly requested
        const allItems = await fetchAllPages<Test>(
          (pageParams) => testsApi.history(pageParams),
          { limit: params?.limit || 500, maxPages: 20 }
        );
        return { items: allItems, lastKey: null };
      } else {
        // Fetch single page by default
        return testsApi.history(params);
      }
    },
  });
}

